<template>
  <div class="container fans-detail-view">
    <div class="title-top">
      <p class="title">{{currentList.subject}}</p>
    </div>

    <div class="footer-div">
      <div class="info-page">
        <p class="date">{{ currentList.regDate }}</p>
      </div>
      <div class="sns-copy" >
        <button id="kakao-link-btn" class="kakao" @click="kakaoBtn">
          <img src="@/assets/img/icon/icon_kakao_btn.png" alt="카카오톡 공유 보내기 버튼">
        </button>
        <button class="faceBook" @click="facebookBtn">
          <img src="@/assets/img/icon/icon_facebook_btn.png" alt="페이스북 공유 보내기 버튼">
        </button>
        <button class="copy" @click="copyBtn">
          <span v-if="copyLink" class="message">주소가 복사되었습니다.</span>
          <img src="@/assets/img/icon/icon_copy.png" alt="주소 복사">
        </button>
      </div>
      <div class="content">
        <div v-if="currentList.content" v-html="currentList.content"></div>
        <div v-else class="content-empty">내용 준비 중입니다.</div>
        <div v-if="currentList.attach1 || currentList.attach2" class="attach">
          첨부파일 :
          <p v-if="currentList.attach1"><a :href="currentList.attach1" download>{{ currentList.attach1_ori_name }}</a></p>
          <p v-if="currentList.attach2"><a :href="currentList.attach2" download>{{ currentList.attach2_ori_name }}</a></p>
        </div>
      </div>
    </div>

    <router-link :to="{name: currentMenu}" class="list-btn">
      <button class="more-btn">
        목록으로
      </button>
    </router-link>

    <div class="next-prev">
      <table>
        <tr v-if="prevList">
          <td class="num">이전글</td>
          <td class="subject">
            <router-link :to="{name: 'fansDetail', params: prevList.detail}">
              <p class="title">{{ prevList.subject }}</p>
              <p class="date">{{ prevList.regDate ? prevList.regDate : '' }}</p>
            </router-link>
          </td>
        </tr>
        <tr v-else>
          <td class="num">이전글</td>
          <td colspan="3" class="noData">이전글이 없습니다.</td>
        </tr>

        <tr v-if="nextList">
          <td class="num">다음글</td>
          <td class="subject">
            <router-link :to="{name: 'fansDetail', params: nextList.detail}">
              <p class="title">{{ nextList.subject }}</p>
              <p class="date">{{ nextList.regDate ? nextList.regDate : '' }}</p>
            </router-link>
          </td>
        </tr>
        <tr v-else>
          <td class="num">다음글</td>
          <td colspan="3" class="noData">다음글이 없습니다.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import {htmlDecode} from "@/lib";

export default {
  name: 'FansDetail',
  data() {
    return {
      currentList: {},
      nextList: {},
      prevList: {},
      copyLink: false,
      currentMenu: this.$route.params.page
    }
  },
  computed: {
    paramsId () {
      return this.$route.params.id
    },
  },
  watch: {
    paramsId () {
      this.getDetail();
    }
  },
  mounted () {
    this.getDetail();
    window.scrollTo(0, 0); // 페이지가 로드될 때 스크롤을 최상단으로 이동
  },

  methods: {
    async getDetail() {
      let apiUrl = ``;
      if(this.currentMenu === 'csrnews') {
        apiUrl = `/notice/news/category`;
        // /notice/news/category/3029?category=csrnews
      }else {
        apiUrl = `/notice/${this.currentMenu}`;
      }

      if(this.currentMenu === 'vod') {
        const param = this.paramsId.split('_');
        apiUrl += `/detail?year=${param[0]}&game_id=${param[1]}`;
      } else {
        apiUrl += `/${this.paramsId}`;
      }

      if(this.currentMenu === 'csrnews') {
        apiUrl += `?category=${this.currentMenu}`;
      }

      const {data} = await this.$http.get(apiUrl);

      if(data.success) {
        const result = data.data;

        result.regDate = dayjs(result.reg_date).utc().format('YYYY-MM-DD HH:mm:ss');
        result.detail = {id: result.b_id, page: this.currentMenu};

        this.currentList = result;
        this.nextList = result.after;
        this.prevList = result.before;

        this.currentList.content = htmlDecode(this.currentList.content);

        if (this.currentMenu === 'vod') {
          this.currentList.subject = result.meet_name + ' ' + result.home_team_name + ' vs ' + result.away_team_name;
          this.currentList.detail.year = dayjs(result.game_date).format('YYYY');
          this.currentList.detail.id = result.game_id;
          this.currentList.content = `
            <div class="video-wrap">
              <iframe id="video" width="100%" height="315" src="${result.highlight}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          `;
          this.currentList.regDate = result.game_date + ' ' + result.game_time;
        } else if (this.currentMenu === 'cheer') {
          this.currentList.content = result.lyrics;
          this.currentList.detail.id = result.youtube_id;
          this.currentList.content = `
            <div class="video-wrap">
              <iframe id="video" width="100%" height="315" src="https://www.youtube.com/embed/${result.youtube_id}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="lyrics">${result.lyrics}</div>
            <div class="cheer-down">
                <a href="${result.download_full_url}" download class="btn">${result.subject} - <strong>응원가 다운로드(MP3)</strong></a>
            </div>
          `;
        }

        if(this.nextList) {
          const nextData = this.nextList;
          this.nextList.regDate = dayjs(nextData.reg_date).utc().format('YYYY-MM-DD HH:mm:ss');
          this.nextList.detail = {id: nextData.b_id, page: this.currentMenu};
          if(this.currentMenu === 'vod') {
            this.nextList.subject = nextData.meet_name + ' ' + nextData.home_team_name + ' vs ' + nextData.away_team_name;
            this.nextList.detail.year = dayjs(nextData.game_date).format('YYYY');
            this.nextList.detail.id = nextData.game_id;
          } else if (this.currentMenu === 'cheer') {
            this.nextList.detail.id = nextData.id;
          }
        }
        if(this.prevList) {
          const prevData = this.prevList;
          this.prevList.regDate = dayjs(prevData.reg_date).utc().format('YYYY-MM-DD HH:mm:ss');
          this.prevList.detail = {id: prevData.b_id, page: this.currentMenu};
          if(this.currentMenu === 'vod') {
            this.prevList.subject = prevData.meet_name + ' ' + prevData.home_team_name + ' vs ' + prevData.away_team_name;
            this.prevList.detail.year = dayjs(prevData.game_date).format('YYYY');
            this.prevList.detail.id = prevData.game_id;
          } else if (this.currentMenu === 'cheer') {
            this.prevList.detail.id = prevData.id;
          }
        }
      }
    },
    kakaoBtn() {
      const imgUrl = this.currentList.thumnail ? this.currentList.thumnail : 'https://www.dragons.co.kr/2018/view/resource/img/common/board_default.png';
      const kakaoData = {
        container: '#kakao-link-btn',
        objectType: 'feed',
        content: {
          title: this.currentList.subject,
          imageUrl: imgUrl,
          link: {
            mobileWebUrl: window.location.href,
            webUrl: window.location.href
          }
        },
        buttons: [
          {
            title: '자세히보기',
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href
            },
          }
        ],
      }

      window.Kakao.Share.createDefaultButton(kakaoData);
    },
    facebookBtn() {
      const thisurl = window.location.href;
      const url = "https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(thisurl);
      window.open(url, "_blank", "width=600, height=400");
    },
    copyBtn() {
      const url = window.location.href
      this.copyLink = true
      window.navigator.clipboard.writeText(url)
      setTimeout(() => {
        this.copyLink = false
      }, 1000);
    }
  }
}
</script>
